import Button from '@/components/Button';
import PageHeader from '@/components/PageHeader';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import OrganizationTable from '@/modules/admin/components/OrganizationTable';
import { OrganizationAddPath } from '@/modules/admin/paths';
import { PlusIcon } from '@heroicons/react/24/solid';

const OrganizationList = () => {
  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  return (
    <>
      <Breadcrumbs />

      <PageHeader title="Organizations">
        <Button
          to={OrganizationAddPath}
          icon={<PlusIcon className="h-5 w-5 mr-1" />}
          variant="secondary"
        >
          Add Organization
        </Button>
      </PageHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <OrganizationTable searchQuery={searchQuery} page={page} onChangePage={handlePageChange} />
    </>
  );
};

export default OrganizationList;
